import { getValue } from "@utils/lodash";
import React from "react";

function DownloadNoCircleSvgComponent(props: any) {
  return (
    <div>
      

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" 
        fill={
            getValue(props, `color`, "") ? getValue(props, `color`, "") : "#000"
        }
        height={
            getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
            getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
      >
          <path d="M160-80v-80h640v80H160Zm320-160L200-600h160v-280h240v280h160L480-240Zm0-130 116-150h-76v-280h-80v280h-76l116 150Zm0-150Z"/>
          </svg>
    </div>
  );
}

export default DownloadNoCircleSvgComponent;
